module.exports = "<div class=\"screenBody applist-component\" xmlns=\"http://www.w3.org/1999/html\">\n    <grid [rows]=\"rows\"\n          [columns]=\"columns\"\n          [oddEven]=\"false\"\n          [rowsOnPage]=\"rowsOnPage\"\n          (action)=\"actionClicked($event)\"></grid>\n</div>\n<modal-dialog #confirmationWindow\n              cancelButtonName=\"Cancel\"\n              agreeButtonName=\"Agree\"\n              [header]=\"headerConfirmationWindow\">\n</modal-dialog>\n"


//////////////////
// WEBPACK FOOTER
// ./src/selector/applist-component/applist.component.html
// module id = 1492
// module chunks = 4